<template>
  <div class="shape-selector-wrapper">
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onShapeSelect('square')"
    >
      <aha-icon
        name="shape-square"
        :maintainColor="true"
        width="25"
        height="25"
        viewBox="0 0 29 28"
      />
    </span>
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onShapeSelect('circle')"
    >
      <aha-icon
        name="shape-circle"
        :maintainColor="true"
        width="25"
        height="25"
        viewBox="0 0 29 28"
      />
    </span>
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onShapeSelect('triangle')"
    >
      <aha-icon
        name="shape-triangle"
        :maintainColor="true"
        width="25"
        height="25"
        viewBox="0 0 32 31"
      />
    </span>
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onShapeSelect('star')"
    >
      <aha-icon
        name="shape-star"
        :maintainColor="true"
        width="27"
        height="27"
        viewBox="0 0 35 33"
      />
    </span>
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onLineSelect('arrow')"
    >
      <aha-icon
        name="line-arrow"
        :maintainColor="true"
        width="24"
        height="24"
        viewBox="0 0 23 22"
      />
    </span>
    <span
      class="p-2 inline-block hover:bg-secondary-15 rounded"
      @click.stop="onLineSelect('line')"
    >
      <aha-icon
        name="line"
        :maintainColor="true"
        width="24"
        height="24"
        viewBox="0 0 23 23"
      />
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    onShapeSelect(type) {
      this.$emit('onShapeSelect', type)
    },
    onLineSelect(type) {
      this.$emit('onLineSelect', type)
    },
  },
}
</script>

<style lang="scss" scoped>
.shape-selector-wrapper {
  @apply rounded-lg shadow-xl bg-base-0 p-1;
  width: 176px;
  height: 94px;
  border: 1px solid rgba(0, 0, 0, 0.1)

}
</style>
